import React, { PropsWithChildren } from 'react';

import type { MenuLayerLevel } from '../../types';

import {
  BettingMenuContext,
  useBettingMenuStateAPIFactory,
} from '../../hooks/betting-menu-state-api';

export type ContainerProps = PropsWithChildren<{
  activeLevel: MenuLayerLevel;
}>;

export const Container: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const bettingMenuProviderValue = useBettingMenuStateAPIFactory('0');

  return (
    <BettingMenuContext.Provider value={bettingMenuProviderValue}>
      {children}
    </BettingMenuContext.Provider>
  );
};
